import { render, staticRenderFns } from "./UserInfos.vue?vue&type=template&id=1cf15e6a&scoped=true&"
import script from "./UserInfos.vue?vue&type=script&lang=ts&"
export * from "./UserInfos.vue?vue&type=script&lang=ts&"
import style0 from "./UserInfos.vue?vue&type=style&index=0&id=1cf15e6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf15e6a",
  null
  
)

export default component.exports